import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { i18n } from '../../../i18n/translate.js';
import { FAIcon } from '../../fa-icon/component.js';
var _excluded = ["ref"];
var ClearIcon = function ClearIcon() {
  return /*#__PURE__*/React.createElement(FAIcon, {
    icon: "xmark"
  });
};
ClearIcon.displayName = "ClearIcon";
var SelectClearTooltip = function SelectClearTooltip(props) {
  var isMulti = props.isMulti,
    _props$children = props.children,
    children = _props$children === undefined ? /*#__PURE__*/React.createElement(ClearIcon, null) : _props$children,
    _props$innerProps = props.innerProps,
    ref = _props$innerProps.ref,
    restInnerProps = _objectWithoutProperties(_props$innerProps, _excluded);
  var tooltipText = isMulti ? i18n.t('Clear All') : i18n.t('Clear Selection');
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "left",
    trigger: ['hover', 'focus'],
    delay: 800,
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, tooltipText)
  }, /*#__PURE__*/React.createElement("div", _extends({
    "data-action": "clear-value",
    ref: ref
  }, restInnerProps), children));
};
SelectClearTooltip.displayName = "SelectClearTooltip";
export { SelectClearTooltip };